import React from "react";
import svg163 from "../../../../assets/svg/svg163.svg";
import svg171 from "../../../../assets/svg/svg171.svg";
import svg152 from "../../../../assets/svg/svg152.svg";

function PaymentSummary({ phoneNumber, purchaseType }) {
  // Format phone number for display (remove country code)
  const formatPhoneNumber = (phone) => {
    if (!phone) return "N/A";
    // If it starts with 254, format it as 07XXXXXXXX
    if (phone.startsWith("254")) {
      return "0" + phone.substring(3);
    }
    return phone;
  };

  return (
    <div className="rounded-[0.75rem] bg-white shadow-[0_0_0_1px_rgba(0,0,0,0.05)] p-[0.75rem] ">
      <div className="flex justify-between items-start">
        <div className="flex flex-col gap-[0.75rem]">
          <div className="flex items-center gap-[0.5rem]">
            <div className="w-[1.5rem] h-[1.5rem] rounded-[0.375rem] bg-ink flex items-center justify-center">
              <img src={svg163} alt="svg163" />
            </div>
            <span className="text-ink font-[500] font-lexendS text-[0.875rem] leading-[1.5rem]">
              Airtime & Data Purchase
            </span>
          </div>

          <div className="flex lg:flex-row flex-col lg:items-center gap-[.5rem]">
            <div className="flex items-center gap-[0.44rem] rounded-[624.9375rem] py-[0.125rem] px-[0.5rem] bg-surface2 w-fit">
              <img
                src={svg171}
                alt="svg171"
                className="w-[0.75rem] h-[0.75rem]"
              />
              <span className="text-body text-[0.625rem] font-[500] leading-[0.9375rem] font-lexendS">
                {formatPhoneNumber(phoneNumber)}
              </span>
            </div>

            <div className="flex items-center gap-[0.44rem] rounded-[624.9375rem] py-[0.125rem] px-[0.5rem] bg-surface2 w-fit">
              <img
                src={svg152}
                alt="svg152"
                className="w-[0.75rem] h-[0.75rem]"
              />
              <span className="text-body text-[0.625rem] font-[500] leading-[0.9375rem] font-lexendS">
                {purchaseType || "Airtime Top-Up"}
              </span>
            </div>
          </div>
        </div>

        <div className="py-[0.125rem] px-[0.5rem] rounded-[624.9375rem] bg-surface2 text-body text-[0.625rem] font-[500] leading-[0.9375rem] font-lexendS">
          Preview
        </div>
      </div>
    </div>
  );
}

export default PaymentSummary;
